import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFileWord, FaFile, FaFileImage, FaFilePdf } from 'react-icons/fa';
import { MdPictureAsPdf, MdClose } from 'react-icons/md';
import { Field } from 'formik';
import firebaseService from 'services/firebaseService.js';
import { PhotoUploadComponent } from 'components/Listing/RenderUploadPhotosForm';
import Switch from 'components/UI/Antd/Switch/Switch';

import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';
import DownloadOutlined from '@ant-design/icons/DownloadOutlined';

import Button from 'components/UI/Antd/Button/Button';
import Modal from 'components/UI/Antd/Modal/Modal';
import attachmentService from 'services/attachment.js';
import { message } from 'antd';
import isNil from 'lodash/isNil';
import loadingGif from 'assets/images/pickapier/loading.svg';
import uploadSVG from 'assets/images/pickapier/upload.svg';
import DragAndDropUploader from 'components/UI/ImageUploader/DragAndDropUploader';
import {useDispatch, useSelector} from "react-redux";
import {
  Wrapper,
  Label,
  Preview,
  PreviewWrapper,
  PreviewInner,
  Actions,
  LoaderWrapper,
  TypeIcon,
  ModalPreviewBody,
  ModalPreviewText,
  ModalActions,
  Action
} from './Document.style';
import { reservationActions } from 'store/slices/reservation/reservationSlice';
import { selectAttachment_Ids } from 'store/slices/reservation/selectors';

message.config({
  top: 100,
  duration: 7,
  maxCount: 1
});

const isImage = preview => preview.type.match(/image\/[^\s]+/g);

const Document = ({
  label,
  type,
  name,
  file,
  marinaName,
  vessel_id,
  onChange = () => {},
  onRemove = () => {},
  actionsAvailable = true,
  disabled = false,
  formik
}) => {
  const { t } = useTranslation();
  const [previewFile, setPreviewFile] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const attachment_ids = useSelector(selectAttachment_Ids);


  const isImage = preview => preview.type.match(/image\/[^\s]+/g);
 
  
  useEffect(()=>{
    if(file && file.name){
        setPreviewFile({
            uid: file.id,
            name: file.name,
            type: file.file_type
          })
    }
    else{
         setPreviewFile(null)
    }
   
  },[file])


  const onDelete = () => {
    const file_name = file.name;
    if(file.id){
        attachmentService.delete({ attachment_id: file.id }).then(res => {
            if (res && res.error_type) {
                message.error(`${file_name} attachment deleting failed`);
            } else {
                onRemove();
                setModalVisible(false);
                setLoaderVisible(false);
                dispatch(reservationActions.setAttachmentIds(attachment_ids.filter( a => a !== file.id)))

            }
        });
    }else{
        firebaseService.deleteFile(file);
    }
    setPreviewFile(null);
    formik.setFieldValue(name, null);
  };

  const getTypeIcon = type => {
    switch (type) {
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <FaFileWord color='#005698' size={20} />;
      case 'application/msword':
        return <FaFileWord color='#005698' size={20} />;
      case 'application/pdf':
        return <FaFilePdf color='#ea4335' size={20} />;
      case 'image/png':
        return <FaFileImage size={20} />;
      case 'image/jpeg':
        return <FaFileImage size={20} />;
      case 'image/gif':
        return <FaFileImage size={20} />;
      case 'image/bmp':
        return <FaFileImage size={20} />;
      case 'image/webp':
        return <FaFileImage size={20} />;
      default:
        return <FaFile color='green' size={50} />;
    }
  };
  

  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Handle file change event
    uploadImage(file)
  };

  const uploadImage = async file => {
    setIsLoading(true);
    
    firebaseService.uploadFile(
      file,
      ({ status, progress, file_path, file_type, name, boater_id, ...args }) => {
        const data = {
          attachment_type: type,
          name,
          file_path,
          file_type
          // ...args,
          // ...apiProps,
        };

        if (status === 'PROCESSING') {
            console.log(`Upload progress: ${progress}%`);
        } else if (status === 'DONE') {
            message.success(`${file.name} ` + t("UPLOADED_SUCCESSFULLY"));
          
          if(boater_id && !isNil(vessel_id)){
            data.vessel_id = vessel_id;
            attachmentService.create(data).then(res => {
                if (res && res.error_type) {
                message.error(`${name} upload failed.`);
                } else {
                    onUploadChange(res);
                    onChange(undefined);
                    // need attachment_ids to attach to reservation done when submitting form
                }
                setIsLoading(false);
            });
          }else{
            onUploadChange(data)
            onChange(data);
          }  
        } else if (status === 'ERROR') {
            message.error(`${file.name} upload failed.`);
        }
      }
    );
  };

  const onUploadChange = (value)=>{
        formik.setFieldValue(name, value);
        setLoaderVisible(true);
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center'}}>

    
        { !previewFile &&<div onClick={handleClick} style={{ display:'flex', alignItems:'flex-end',  cursor: 'pointer' }}>
            <img alt='upload pic' src={uploadSVG} style={{padding:'10px', paddingLeft:'0px'}} />
            <Label style={{color:'#0036B1'}}>{t("UPLOAD") + label}</Label>
            
            <input
            type="file"
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleFileChange}
            accept='image/*,.pdf,.doc,.docx'
            multiple={false}
            />
        </div>  }
        
        
        {previewFile && <span > {previewFile.name}</span>}
        { previewFile &&  <TypeIcon style={{ width:'20px', marginLeft:'2px'}}>{getTypeIcon(previewFile.type)}</TypeIcon>}
        {(previewFile && !disabled) && 
                (<Button
                    className='delete_button'
                    htmlType='button'
                    onClick={onDelete}
                    type='link'
                >
                <DeleteOutlined />
                </Button>)}
    </div>
  );
};

export default Document;
